import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import MomentosNavabr from "../components/MomentosNavabr";

const Main = (props) => {
    const location = useLocation();
    const { id } = useParams();
    const { uid } = useSelector((state) => state.authUser);
    const history = useHistory();
    if (!uid && location.pathname !== `/main/qr-upload/${id}`) {
        history.push("/auth/login");
    }
    return (
        <>
            {location.pathname !== `/main/qr-upload/${id}` ? (
                <>
                    <MomentosNavabr />
                    {props.children}
                </>
            ) : (
                <>{props.children}</>
            )}
        </>
    );
};

export default Main;
